import React from "react";
import { useState, useEffect } from "react";
import Pagination from "../../components/Pagination/Pagination";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";
import AuthServiceStroage from "../../utils/auth_service/AuthServiceStorage";
import PaginationInfo from "../../components/PaginationInfo/PaginationInfo";
import UpdateManuscriptStatus from "./UpdateManuscriptStatus";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import * as XLSX from "xlsx";

const DoiFilters = (projectId) => {

  const [project, setProject] = useState("");
  const [projects, setProjects] = useState([]);
  const localStorageService = LocalStorageService.getService();
  const [projectReport, setprojectReport] = useState([]);
  const [doiFilters , setdoiFilters]= useState([]);
  const [selectedDoiFilter, setSelectedDoiFilter] = useState("");
  const [selectedAction , setSelectedAction]=useState();

  const apiService = new AxiosService();

  useEffect(() => {
    apiService
      .getProjectList()
      .then((response) => {
        console.log(response.data);
        setProjects(response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
      apiService.getAllDoiFilters()
      .then((response) =>{
        console.log(response.data.data);
        setdoiFilters(response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });

  }, []);
  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    setProject(projectId);
    const selectedProject = projects.find((project) => {
      if (project.projectId == projectId) {
        return project;
      }
    });
    localStorageService.setProjectDetails(
      JSON.stringify({
        projectId: projectId,
        projectName: selectedProject ? selectedProject.projectName : "",
      })
    );
  };

  const handleDoiFilterChange = (e) => {
    setSelectedDoiFilter(e.target.value);
  };

const handleResolveClick = () => {
  setSelectedAction("resolved");
  apiService
    .updateDoiFlagStatus(project, selectedAction, selectedDoiFilter)
    .then((response) => {
      console.log(response.data);
    })
    .catch((error) => {
      toast.error(error.response.data.message, { autoClose: 3000 });
    });
    
};

const handleUnresolveClick = () => {
    setSelectedAction("unresolved");
    apiService
      .updateDoiFlagStatus(selectedDoiFilter, selectedAction, project)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
};


return (
  <div className="container-fluid">
    <h3 className="text-center">DOI Filters</h3>

    <label htmlFor="project" className="form-label">
      Project
    </label>
    <select
      className="form-select form-select-sm"
      id="project"
      name="project"
      style={{ width: "300px" }}
      onChange={handleProjectChange}
    >
      <option value="">Choose Project..</option>
      {projects &&
        projects.map((project) => (
          <option
            value={project.projectId}
            className="bg-gray-100 hover:bg-gray-200"
            key={project.projectId}
          >
            {project.projectName}
          </option>
        ))}
    </select>

    {project !== "" && (
      <div className="pt-5 d-flex align-items-end gap-2">
        <div>
          <label htmlFor="doiFilter" className="form-label">
            DOI Filter
          </label>
          <select
            className="form-select form-select-sm"
            id="doiFilter"
            name="doiFilter"
            style={{ width: "300px" }}
            onChange={handleDoiFilterChange}
          >
            <option value="">Choose DOI Filter..</option>
            {doiFilters &&
              doiFilters.map((filter) => (
                <option key={filter} value={filter}>
                  {filter}
                </option>
              ))}
          </select>
        </div>

        <button
          type="button"
          className="btn btn-success btn-sm"
          onClick={handleResolveClick}
        >
          Resolve
        </button>

        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={handleUnresolveClick}
        >
          Unresolve
        </button>
      </div>
    )}
  </div>
);

};
export default DoiFilters;
